"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ProductEvent.js.map